import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { lastValueFrom } from "rxjs";
import { singleton } from "tsyringe";

import { DiscountServiceStrategyInterface } from "./DiscountServiceStrategyInterface";

@singleton()
export class DiscountServiceShopifyApiStrategy
    implements DiscountServiceStrategyInterface
{
    constructor(private readonly apiClient: ApiClientInterface) {}

    async applyDiscount(params: { discountCode: string }): Promise<unknown> {
        return lastValueFrom(
            this.apiClient.get({
                url: `/discount/${encodeURIComponent(params.discountCode)}`,
                responseType: "text",
            })
        );
    }
}
